<section
  class="border-default bg-elevated flex flex-col rounded-sm border"
  data-testid="occupation-legend">
  <button
    type="button"
    class="hover:bg-interactive flex cursor-pointer items-center gap-1.5 rounded-sm px-2 py-1.5 text-left transition-colors"
    [attr.aria-expanded]="!collapsed()"
    (click)="toggle()">
    <i [class]="ICONS.info" class="text-text-tertiary shrink-0"></i>
    <span class="text-text-secondary flex-1 text-[11px] font-semibold">
      {{ 'visualization.occupation.legend.title' | translate }}
    </span>
    <i
      [class]="ICONS.caretDown"
      class="text-text-tertiary shrink-0 transition-transform duration-200"
      [class.rotate-180]="!collapsed()"></i>
  </button>

  <div class="legend-body" [class.legend-expanded]="!collapsed()">
    <div class="min-h-0 overflow-hidden">
      <ul
        class="text-text-secondary flex flex-col gap-1 px-2 pb-2 text-[11px] leading-snug">
        @for (line of lines(); track line) {
          <li>{{ line | translate }}</li>
        }
      </ul>
    </div>
  </div>
</section>
